import AiStarIcon from '../Icons/AiStarIcon';

export default function MessageRelated({
  suggestions = [],
  sendMessage,
}: {
  suggestions: string[];
  sendMessage: (message: string) => void;
}) {
  // suggestions = [
  //   'Solana的24小时价格变动是多少',
  //   'The Solana ecosystem is a thriving space with ',
  //   'Solana的流通供应量是多少',
  //   'Solana的未来30天价格预测如何',
  //   'Solana的7天价格变动是多少',
  // ]

  return (
    suggestions &&
    suggestions.length > 0 && (
      <div className="flex flex-col pt-4 gap-[10px] text-text-secondary">
        {suggestions?.map((suggestion, i) => (
          <div key={i}>
            <div
              className="cursor-pointer text-sm inline-flex gap-2 font-normal items-center border dark:border-[#1E1E1E] border-[#EFEFEF] px-3 py-[10px] rounded-[12px]"
              onClick={() => sendMessage(suggestion)}
            >
              <AiStarIcon />
              <span className="transition duration-200 hover:text-[#A772FF]">{suggestion}</span>
            </div>
          </div>
        ))}
      </div>
    )
  );
}
